/**
 * Logo Configuration
 * ロゴのサイズを一元管理
 *
 * 利用可能なサイズ（縦型ロゴ）:
 * - logo-v-h32.png (32x32px)   → h-8
 * - logo-v-h36.png (36x36px)   → h-9
 * - logo-v-h40.png (40x40px)   → h-10
 * - logo-v-h44.png (44x44px)   → h-11
 * - logo-v-h48.png (48x48px)   → h-12
 * - logo-v-h56.png (56x56px)   → h-14
 * - logo-v-h64.png (64x64px)   → h-16
 * - logo-v-h80.png (80x80px)   → h-20
 * - logo-v-h96.png (96x96px)   → h-24
 * - logo-v-h128.png (128x128px) → h-32
 * - logo-v-h160.png (160x160px) → h-40
 * - logo-v-h180.png (180x180px) → h-44
 * - logo-v.png (180x180px)      → フルサイズ
 */

export const LOGO_CONFIG = {
  // ロゴファイル名（publicフォルダ内）
  src: '/logo-v-h180.png',

  // Tailwind高さクラス
  heightClass: 'h-44',

  // モバイル/デスクトップで分ける場合はこちらを使用
  // heightClass: 'h-12 md:h-16',
} as const;
